import React from "react";
import "tailwindcss/base.css";
import "tailwindcss/components.css";
import "tailwindcss/utilities.css";
import { useLanguage } from "../../LanguageContext";
import translations from "../../translation_about";

function About() {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <>
      <section
        id="about"
        className="mb-16 scroll-mt-16 md:mb-24 lg:mb-36 lg:scroll-mt-24"
        aria-label="About me"
      >
        {/* HUD Header */}
        {/* <div className="sticky top-0 z-20 -mx-6 mb-8 w-screen bg-[#021327]/90 px-6 py-5 backdrop-blur border-b border-cyan-500/20 md:-mx-12 md:px-12 lg:sr-only lg:relative lg:top-auto lg:mx-auto lg:w-full lg:px-0 lg:py-0 lg:opacity-0">
          <h2 className="text-sm font-bold uppercase tracking-widest text-cyan-400 lg:sr-only flex items-center gap-2">
            <div className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse"></div>
            {t.navbar_text}
          </h2>
        </div> */}
        
        {/* Enhanced content with consistent styling */}
        <div className="relative">
          {/* Section indicator */}
          <div className="flex items-center mb-6">
            <div className="flex items-center text-cyan-400 font-mono text-xs uppercase tracking-wider">
              <span className="w-2 h-2 bg-cyan-400 rounded-full mr-2 animate-pulse"></span>
              <span className="opacity-70">PROFILE.OVERVIEW</span>
            </div>
            <div className="flex-1 h-px bg-gradient-to-r from-cyan-400/30 to-transparent ml-4"></div>
          </div>

          <div className="space-y-4">
            <p className="text-gray-300 leading-relaxed font-mono text-sm">
              <span className="text-cyan-400 opacity-70">&gt;</span> {t.p1}
              <a
                className="font-semibold text-cyan-400 hover:text-cyan-300 focus-visible:text-cyan-300 transition-colors duration-300 relative group"
                href="https://www.itk.ac.id/"
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Kalimantan Institute of Technology (opens in a new tab)"
              >
                <span className="relative z-10">{t.school}</span>
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-cyan-400 transition-all duration-300 group-hover:w-full opacity-60"></span>
              </a>
              {t.p2}
            </p>
            <p className="text-gray-300 leading-relaxed font-mono text-sm">
              <span className="text-cyan-400 opacity-70">&gt;</span> {t.p3}
            </p>
            
            <p className="text-gray-300 leading-relaxed font-mono text-sm">
              <span className="text-cyan-400 opacity-70">&gt;</span> {t.p4}
            </p>
          </div>

          {/* Decorative elements */}
          <div className="absolute -top-2 -right-2 w-4 h-4 border-t border-r border-cyan-400/20"></div>
          <div className="absolute -bottom-2 -left-2 w-4 h-4 border-b border-l border-cyan-400/20"></div>
        </div>
      </section>
    </>
  );
}

export default React.memo(About);
